export const EARNINGS_CALCULATOR_CONSTANTS = {
  SUBTITLE: "EARNINGS CALCULATOR",
  TITLE: "How much can you earn?",
  DESCRIPTION:
    "Pick how many people you refer and the plan they choose. You earn 25% of their annual plan.",
  PEOPLE_LABEL: "People you refer",
  PLAN_LABEL: "Plan they choose",
  YOU_COULD_EARN_LABEL: "You could earn",
  COPY_BUTTON_TEXT: "Copy my referral link",
  DEFAULT_CURRENCY_SYMBOL: "₹",
  COMMISSION_RATE: 25,
  PERCENTAGE_DIVISOR: 100,
  ANNUAL_SUFFIX: "/yr",
  REFERRAL_SUFFIX_SINGULAR: "referral",
  REFERRAL_SUFFIX_PLURAL: "referrals",

  PEOPLE_OPTIONS: [
    { ID: "people-5", VALUE: 5, LABEL: "5" },
    { ID: "people-10", VALUE: 10, LABEL: "10" },
    { ID: "people-15", VALUE: 15, LABEL: "15" },
  ],

  PLANS: [
    {
      ID: "pro-plan",
      NAME: "Pro Plan",
      ANNUAL_PRICE: 30000,
      DISPLAY_PRICE: "₹30,000/yr",
    },
    {
      ID: "premium-plan",
      NAME: "Premium Plan",
      ANNUAL_PRICE: 108000,
      DISPLAY_PRICE: "₹1,08,000/yr",
    },
  ],

  BREAKDOWN_COUNTS: [5, 10, 15],
};
